import styled from "styled-components";

export const Wrapper = styled.div<{ disabled: boolean | undefined }>`
    ${({ disabled }) => disabled && `
        pointer-events: none;
        opacity: .5;
    `}
`;